import { message } from "antd";
import Router from "../..";
import { handleApiError } from "./indexApi";

const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const agencyApi = {
  getInvitedCreators: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/agency/get/invited`,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "초대된 크리에이터 목록 조회에 실패했습니다.");
      return null;
    }
  },

  inviteCreator: async (email) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/agency/influencer/invite`,
        { user_email: email },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data.result) {
        message.success("크리에이터 초대가 완료되었습니다.");
        return true;
      }
      return false;
    } catch (err) {
      handleApiError(err, "크리에이터 초대에 실패했습니다.");
      return false;
    }
  },

  cancelInvitedCreators: async (id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/agency/invite/cancel`,
        { id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("초대가 취소되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "초대 취소에 실패했습니다.");
      return false;
    }
  },

  getCreatorsByAgency: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/agency/get/influencers`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "크리에이터 목록 조회에 실패했습니다.");
      return null;
    }
  },

  deleteCreator: async (id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/agency/delete/influencer`,
        { user_id: id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("선택한 크리에이터가 제외되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "크리에이터 제외에 실패했습니다.");
      return false;
    }
  },

  // 소셜 인증 요청 알림
  requestSocialAuth: async (target_user_id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/agency/request/alarm`,
        { target_user_id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("소셜 인증 요청이 완료되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "소셜 인증 요청에 실패했습니다.");
      return false;
    }
  },
};
